import { formatDateToMMDDYYYY } from '../../utils/helpers'
import { client } from './client'

const attachParams = (resource, params) => {
  if (Object.keys(params.filter).length) {
    const filters = []
    Object.keys(params.filter).forEach((key) => {
      switch (key) {
        case 'status':
          filters.push(`_status=${params.filter[key]}`)
          break
        case 'patientName':
          filters.push(`_patientName=${params.filter[key]}`)
          break
        case 'patientDoB':
          filters.push(`_patientDoB=${formatDateToMMDDYYYY(params.filter[key])}`)
          break
        case '_order':
          filters.push(`_order=${params.filter[key]}`)
          break
        case 'requisitionFilter':
          filters.push(`requisitionFilter=${params.filter[key]}`)
          break
        case 'providerId':
          filters.push(`_provider=${params.filter[key]}`)
          break
        case 'shopifyOrderNumber':
          filters.push(`_shopifyOrderNumber=${params.filter[key]}`)
          break
        case 'kitId':
          filters.push(`_kitId=${params.filter[key]}`)
          break
        case 'result':
          filters.push(`_result=${params.filter[key]}`)
          break
        case 'acknowledgment':
          filters.push(`_ack=${params.filter[key]}`)
          break
        case 'email':
          filters.push(`_email=${params.filter[key]}`)
          break
        case 'requestStatus':
          filters.push(`_requestStatus=${params.filter[key]}`)
          break
        case 'shippedFinancialStatus':
          filters.push(`_shippedFinancialStatus=${params.filter[key]}`)
          break
        case 'showTestedKits':
          filters.push(`_showTestedKits=${params.filter[key]}`)
          break
        case 'providerGroupId':
          filters.push(`_providerGroupId=${params.filter[key]}`)
          break
        case 'clinicName':
          filters.push(`_clinicName=${encodeURIComponent(params.filter[key])}`)
          break
        case 'patientDob':
          // Send as YYYY-MM-DD; backend will do date-only prefix comparison
          filters.push(`_patientDob=${params.filter[key]}`)
          break
        case 'createdDate':
          filters.push(`_createdDate=${params.filter[key]}`)
          break
        case 'requestId':
          filters.push(`_requestId=${encodeURIComponent(params.filter[key])}`)
          break
        case 'shippedInvoiceId':
          filters.push(`_shippedInvoiceId=${encodeURIComponent(params.filter[key])}`)
          break
        case 'testedInvoiceId':
          filters.push(`_testedInvoiceId=${encodeURIComponent(params.filter[key])}`)
          break
        case '_pageSize':
          filters.push(`_pageSize=${params.filter[key]}`)
          break
        case '_page':
          filters.push(`_page=${params.filter[key]}`)
          break
        default:
          break
      }
    })

    resource += `?${filters.join('&')}`
  }

  return resource
}

const dataProvider = {
  getList: (resource, params) => {
    if (resource === 'provider-portal/kit-requests') {
      const { page, perPage } = params.pagination
      const paginatedParams = {
        ...params,
        filter: {
          ...params.filter,
          _pageSize: perPage,
          _page: page,
        },
      }
      const newResource = attachParams(resource, paginatedParams)
      return client()
        .get(newResource)
        .then((res) => res.data)
    }
    const newResource = attachParams(resource, params)
    return client()
      .get(newResource, params)
      .then((res) => {
        return res.data
      })
  },
  getOne: (resource, params) => {
    return client().get(`${resource}/${params.id}`, params)
  },
  getMany: (resource, params) => {
    // resolve api calls and then put responses in format expected by react-admin
    return client()
      .put(`${resource}/many`, params)
      .then((res) => {
        return {
          data: res.data,
        }
      })
  },
  getManyReference: (resource, _params) => {
    return client().get(resource)
  },
  update: (resource, params) => {
    return client().put(`${resource}/${params.id}`, params.data)
  },
  updateMany: (resource, params) => {
    return client().put(`${resource}/many`, params)
  },
  create: (resource, _params) => {
    return client().post(resource, _params.data)
  },
  delete: (resource, params) => {
    return client().delete(`${resource}/${params.id}`, params)
  },
  deleteMany: (resource, params) => {
    return params.ids.map((id) => {
      return client().put(`${resource}/${id}`, params)
    })
  },
}

export default dataProvider
